import React from 'react';
import HybridSectionPage from './HybridSectionPage';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const EzParentHybridGroupFacilitation = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter vidSrc={1196356942} />
    </div>
  );
};

export default EzParentHybridGroupFacilitation;
